import { useState, useEffect } from "react";
import { ChangePassword, getDatabaseVersion } from "../../api";
import mixpanel from "mixpanel-browser";

interface SettingsController {
  // Password management
  password: string;
  changePassword: () => void;
  setPassword: (password: string) => void;
  passwordDrawerOpen: boolean;
  setPasswordDrawerOpen: (open: boolean) => void;
  loading: boolean;
  errorMessage: string;

  // Logout
  logOutModalOpen: boolean;
  setLogOutModalOpen: (open: boolean) => void;
  handleLogout: () => void;

  // DB Version
  dbVersion: string;
}

export const useSettingsController = (): SettingsController => {
  const [password, setPassword] = useState<string>("");
  const [passwordDrawerOpen, setPasswordDrawerOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [logOutModalOpen, setLogOutModalOpen] = useState<boolean>(false);
  const [dbVersion, setDbVersion] = useState<string>("0.0.0");

  const handleLogout = () => {
    window.localStorage.removeItem("token");
    window.location.href = "../app/login";
  };

  const performPasswordChange = async () => {
    // mixpanel.track("Change Password Attempt");

    setLoading(true);

    ChangePassword(password).then((res) => {
      setTimeout(() => {
        if (res.success === true) {
          console.log("Password changed successfully");

          setErrorMessage("");
          setPassword("");
          setPasswordDrawerOpen(false);
        } else {
          console.log("Error changing password");
          // toast({
          //   title: "Error changing password",
          //   description: res.msg,
          //   status: "error",
          //   duration: 9000,
          //   isClosable: true,
          // });

          setErrorMessage(res.msg);
        }
        setLoading(false);
      }, 200);
    });
  };

  // Fetch database version
  useEffect(() => {
    const fetchDbVersion = async () => {
      try {
        const data = await getDatabaseVersion();
        setDbVersion(data.toString());
      } catch (error) {
        console.error("Error fetching database version:", error);
      }
    };

    fetchDbVersion();
  }, []);

  return {
    password,
    changePassword: performPasswordChange,
    setPassword,
    passwordDrawerOpen,
    setPasswordDrawerOpen,
    loading,
    errorMessage,
    logOutModalOpen,
    setLogOutModalOpen,
    handleLogout,
    dbVersion,
  };
};
